export interface Comic {
  id: number;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  categorySlug: string;
  tags: string[];
  rating: number;
  views: number;
  chapters: number;
  status: '连载中' | '已完结';
  updatedAt: string;
  createdAt: string;
  chapters_list: Chapter[];
}

export interface Chapter {
  id: number;
  title: string;
  number: number;
  updatedAt: string;
  content: string;
}

export interface Category {
  name: string;
  slug: string;
  description: string;
  count: number;
}

export const categories: Category[] = [
  { name: '全部', slug: 'all', description: '所有韩国漫画作品', count: 156 },
  { name: '浪漫爱情', slug: 'romance', description: '甜蜜浪漫的爱情故事', count: 48 },
  { name: '剧情', slug: 'drama', description: '引人入胜的剧情漫画', count: 35 },
  { name: '悬疑推理', slug: 'mystery', description: '扣人心弦的悬疑故事', count: 22 },
  { name: '奇幻冒险', slug: 'fantasy', description: '奇幻世界的冒险旅程', count: 28 },
  { name: '都市生活', slug: 'urban', description: '都市人的真实生活写照', count: 23 },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '她的秘密花园',
    author: '金智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20cover%20illustration%20featuring%20a%20young%20woman%20in%20a%20romantic%20garden%20setting%2C%20soft%20pastel%20colors%2C%20delicate%20flowers%2C%20dreamy%20atmosphere%2C%20manhwa%20art%20style%2C%20clean%20composition%2C%20warm%20lighting%2C%20emotional%20portrait%2C%20Korean%20comic%20aesthetic&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '平凡的女大学生林小柔意外发现自己拥有一座神秘花园的钥匙。在这座花园里，她遇见了三位性格各异的守护者——温柔体贴的春之守护者、热情似火的夏之守护者、以及神秘莫测的夜之守护者。随着花园的秘密逐渐揭开，一段跨越时空的浪漫故事悄然展开。',
    category: '浪漫爱情',
    categorySlug: 'romance',
    tags: ['浪漫', '奇幻', '校园'],
    rating: 9.6,
    views: 1285000,
    chapters: 86,
    status: '连载中',
    updatedAt: '2026-08-03',
    createdAt: '2025-03-15',
    chapters_list: [
      { id: 1, title: '第1话：意外的钥匙', number: 1, updatedAt: '2025-03-15', content: '第一话的内容...在一个普通的春日午后，林小柔在整理祖母留下的遗物时，发现了一把锈迹斑斑的铜钥匙。钥匙上雕刻着精美的花纹，像是某种古老的符号。当她握住钥匙的瞬间，一阵奇异的光芒将她笼罩...' },
      { id: 2, title: '第2话：花园的入口', number: 2, updatedAt: '2025-03-22', content: '第二话的内容...光芒消散后，林小柔发现自己站在一片从未见过的花园中。各色奇异的花朵竞相绽放，空气中弥漫着甜美的花香。就在这时，一个温柔的声音在她身后响起："欢迎回来，花园的主人。"' },
      { id: 3, title: '第3话：春之守护者', number: 3, updatedAt: '2025-03-29', content: '第三话的内容...春之守护者韩星辰向林小柔解释了花园的秘密——这座花园连接着人类世界和精灵世界，而她是被选中的花园主人。但危险也在悄然逼近...' },
    ],
  },
  {
    id: 2,
    title: '暗夜追踪者',
    author: '朴正宇',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20mystery%20Korean%20webtoon%20cover%20featuring%20a%20detective%20in%20a%20rainy%20urban%20alley%2C%20noir%20atmosphere%2C%20dramatic%20lighting%2C%20tense%20mood%2C%20manhwa%20art%20style%2C%20cinematic%20composition%2C%20dark%20tones%20with%20red%20accent%2C%20Korean%20comic%20aesthetic&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '首尔江南区发生了一系列离奇失踪案件，所有受害者都在深夜独自外出后消失，没有任何目击证人和线索。前刑警李泰俊因一次意外被迫离开警队，如今成为一名私家侦探。当他的妹妹也成为失踪者之一时，他不得不重新踏上追查真相的道路，却发现这背后隐藏着一个令人不寒而栗的庞大阴谋。',
    category: '悬疑推理',
    categorySlug: 'mystery',
    tags: ['悬疑', '犯罪', '推理'],
    rating: 9.4,
    views: 987000,
    chapters: 64,
    status: '连载中',
    updatedAt: '2026-08-02',
    createdAt: '2025-06-10',
    chapters_list: [
      { id: 1, title: '第1话：消失的妹妹', number: 1, updatedAt: '2025-06-10', content: '深夜的首尔，霓虹灯闪烁。李泰俊站在警局门口，手中紧握着妹妹最后发来的短信："哥哥，有人跟踪我。"距离妹妹失踪已经过去72小时...' },
      { id: 2, title: '第2话：旧案重提', number: 2, updatedAt: '2025-06-17', content: '李泰俊翻出了三年前的一桩悬案档案——同样的失踪模式，同样的毫无线索。他开始怀疑这两起案件之间存在某种联系...' },
    ],
  },
  {
    id: 3,
    title: '重生之商业帝国',
    author: '李秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20modern%20Korean%20drama%20webtoon%20cover%20featuring%20a%20confident%20businessman%20in%20a%20luxury%20office%20setting%2C%20clean%20sophisticated%20style%2C%20warm%20golden%20lighting%2C%20manhwa%20art%20style%2C%20corporate%20aesthetic%2C%20Korean%20comic%20illustration&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '顶级投资银行家韩志勋在事业巅峰时遭人陷害，含冤而死。当他再次睁开眼睛时，发现自己回到了二十年前，一切重新开始。带着前世的记忆和经验，他决心在商界重新崛起，同时找出当年陷害自己的真凶。但重来一次的人生并不像想象中那么简单，新的挑战和抉择接踵而至。',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['重生', '商战', '复仇'],
    rating: 9.5,
    views: 1560000,
    chapters: 92,
    status: '连载中',
    updatedAt: '2026-08-04',
    createdAt: '2025-01-20',
    chapters_list: [
      { id: 1, title: '第1话：最后的记忆', number: 1, updatedAt: '2025-01-20', content: '韩志勋站在天台边缘，身后的脚步声越来越近。他回头看了一眼那些曾经信任的面孔，嘴角露出一丝苦笑。"你们以为这样就能赢吗？"他纵身一跃...' },
      { id: 2, title: '第2话：回到过去', number: 2, updatedAt: '2025-01-27', content: '刺眼的阳光将韩志勋唤醒。他猛地坐起身，发现自己躺在一间狭小的出租屋里。桌上日历显示着：2006年3月15日。他回到了二十年前...' },
    ],
  },
  {
    id: 4,
    title: '魔法学院特优班',
    author: '崔民秀',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20vibrant%20fantasy%20Korean%20webtoon%20cover%20featuring%20students%20in%20magical%20academy%20uniforms%2C%20magical%20sparks%20and%20runes%2C%20colorful%20and%20energetic%20style%2C%20manhwa%20art%2C%20bright%20warm%20colors%2C%20Korean%20comic%20illustration%2C%20adventure%20theme&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    description: '在普通人眼中，圣光学院只是一所普通的私立高中。但在魔法界，这里是培养顶尖魔法师的最强学府。毫无魔法天赋的普通少年郑宇辰，因一次意外被学院破格录取，被分到了全是问题学生的"特优班"。在这个天赋至上的世界里，他要如何用自己的方式证明——努力也能创造奇迹？',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    tags: ['魔法', '校园', '热血'],
    rating: 9.3,
    views: 1120000,
    chapters: 78,
    status: '连载中',
    updatedAt: '2026-08-01',
    createdAt: '2025-04-05',
    chapters_list: [
      { id: 1, title: '第1话：没有魔法的少年', number: 1, updatedAt: '2025-04-05', content: '圣光学院入学测试现场。所有考生都在展示各自的魔法天赋——火球术、冰霜术、风刃术。只有郑宇辰站在原地，手心冒汗，连一个火花都搓不出来...' },
      { id: 2, title: '第2话：特优班的秘密', number: 2, updatedAt: '2025-04-12', content: '"欢迎来到特优班！"班主任笑眯眯地说。郑宇辰环顾四周——教室里只有五个学生，有人在睡觉，有人在打游戏，还有人在天花板上倒挂着..."这就是最强的班级？"' },
    ],
  },
  {
    id: 5,
    title: '都市夜行录',
    author: '尹彩英',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stylish%20urban%20Korean%20webtoon%20cover%20featuring%20young%20professionals%20in%20Seoul%20nightlife%2C%20neon%20lights%2C%20modern%20city%20backdrop%2C%20chic%20fashion%2C%20manhwa%20art%20style%2C%20warm%20city%20lights%2C%20Korean%20comic%20aesthetic&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '在首尔这座不夜城里，五个来自不同行业的年轻人因缘际会走到了一起。广告公司设计师、深夜便利店店员、独立音乐人、美食博主和程序员——他们在夜晚各自追寻着梦想，在白天面对着现实的压力。一部关于都市年轻人的友情、爱情与成长的温暖故事。',
    category: '都市生活',
    categorySlug: 'urban',
    tags: ['都市', '友情', '成长'],
    rating: 9.2,
    views: 865000,
    chapters: 56,
    status: '连载中',
    updatedAt: '2026-07-30',
    createdAt: '2025-07-18',
    chapters_list: [
      { id: 1, title: '第1话：深夜的便利店', number: 1, updatedAt: '2025-07-18', content: '凌晨两点，首尔弘大。便利店的自动门叮咚一声打开，一个戴着棒球帽的女孩匆匆走进来。正在整理货架的兼职生金泰亨抬头看了一眼，继续低下头干活...' },
    ],
  },
  {
    id: 6,
    title: '逆鳞',
    author: '姜东元',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20historical%20Korean%20drama%20webtoon%20cover%20featuring%20a%20warrior%20in%20traditional%20Korean%20clothing%2C%20epic%20landscape%2C%20dramatic%20sky%2C%20manhwa%20art%20style%2C%20warm%20earth%20tones%2C%20Korean%20comic%20illustration&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '朝鲜王朝末年，权臣当道，民不聊生。出身贫寒的少年朴镇宇因缘际会习得绝世武艺，化名"逆鳞"在暗夜中行侠仗义。然而当他发现自己要对抗的敌人竟是自己的亲生父亲时，一场关于忠孝与正义的艰难抉择就此展开。',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['古装', '武侠', '权谋'],
    rating: 9.7,
    views: 1890000,
    chapters: 120,
    status: '已完结',
    updatedAt: '2026-06-15',
    createdAt: '2024-09-01',
    chapters_list: [
      { id: 1, title: '第1话：月下的刺客', number: 1, updatedAt: '2024-09-01', content: '月光如水，洒在汉阳城的青瓦之上。一道黑影掠过屋顶，如鬼魅般无声无息。今夜的目标是当朝权臣金判书——传闻他勾结倭寇，出卖国家利益...' },
    ],
  },
  {
    id: 7,
    title: '星之声',
    author: '韩素希',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dreamy%20romantic%20Korean%20webtoon%20cover%20featuring%20a%20couple%20under%20starry%20night%20sky%2C%20soft%20pastel%20colors%2C%20emotional%20atmosphere%2C%20manhwa%20art%20style%2C%20tender%20moment%2C%20Korean%20comic%20aesthetic%2C%20warm%20romantic%20illustration&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '天生患有罕见听力障碍的女孩崔星儿，只能听到特定频率的声音。在寂静的世界里，她意外发现每当仰望星空时，能听到来自遥远星球的奇妙旋律。更神奇的是，她发现有一个神秘的电台主播每晚都会播放着同样的旋律。一段跨越声音障碍的浪漫故事就此展开。',
    category: '浪漫爱情',
    categorySlug: 'romance',
    tags: ['浪漫', '治愈', '音乐'],
    rating: 9.5,
    views: 1340000,
    chapters: 72,
    status: '连载中',
    updatedAt: '2026-08-03',
    createdAt: '2025-05-12',
    chapters_list: [
      { id: 1, title: '第1话：寂静的世界', number: 1, updatedAt: '2025-05-12', content: '崔星儿的世界是安静的。从出生起，她的双耳就只能听到极其微弱的声音。医生说她患有一种罕见的听觉神经障碍。但这并不妨碍她成为一个乐观开朗的女孩...' },
    ],
  },
  {
    id: 8,
    title: '进化危机',
    author: '赵敏浩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20Korean%20webtoon%20cover%20featuring%20a%20post-apocalyptic%20city%20with%20enhanced%20humans%2C%20dramatic%20atmosphere%2C%20manhwa%20art%20style%2C%20warm%20orange%20and%20dark%20tones%2C%20Korean%20comic%20illustration%2C%20action%20scene&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '近未来，一种神秘的病毒在全球蔓延。感染者不会死亡，而是会发生基因突变，获得超乎常人的能力。政府将这些突变者称为"进化者"，并建立了严格的管控体系。少年金俊秀在感染病毒后获得了操纵时间的能力，却也因此卷入了进化者与普通人之间的激烈冲突。',
    category: '悬疑推理',
    categorySlug: 'mystery',
    tags: ['科幻', '超能力', '末世'],
    rating: 9.1,
    views: 756000,
    chapters: 48,
    status: '连载中',
    updatedAt: '2026-07-28',
    createdAt: '2025-09-20',
    chapters_list: [
      { id: 1, title: '第1话：零号病人', number: 1, updatedAt: '2025-09-20', content: '2035年，首尔。电视新闻里循环播放着紧急通告："请所有市民避免前往市中心区域，如有发热、眩晕症状请立即就医。"金俊秀关掉电视，却发现自己的指尖正在微微发光...' },
    ],
  },
  {
    id: 9,
    title: '恋爱方程式',
    author: '郑多恩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cute%20romantic%20comedy%20Korean%20webtoon%20cover%20featuring%20students%20in%20school%20setting%2C%20cheerful%20vibe%2C%20manhwa%20art%20style%2C%20bright%20warm%20colors%2C%20Korean%20comic%20illustration%2C%20youth%20romance&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '数学天才少女安多妍的人生信条是"万事皆可用公式求解"，包括恋爱。她制定了一套完美的恋爱方程式来追求校草学长。然而计划永远赶不上变化，当一个看似平凡的转学生开始打乱她所有的计算时，她才明白——爱情从来就不是一道数学题。',
    category: '浪漫爱情',
    categorySlug: 'romance',
    tags: ['校园', '恋爱', '喜剧'],
    rating: 9.4,
    views: 1020000,
    chapters: 68,
    status: '连载中',
    updatedAt: '2026-08-02',
    createdAt: '2025-08-05',
    chapters_list: [
      { id: 1, title: '第1话：完美的计划', number: 1, updatedAt: '2025-08-05', content: '"恋爱成功率 = (外貌分×0.4 + 性格分×0.3 + 缘分值×0.3) × 主动系数。"安多妍在笔记本上写下这行字，满意地点了点头。追求校草的计划，正式开始！' },
    ],
  },
  {
    id: 10,
    title: '异世界餐厅',
    author: '柳成勋',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20charming%20fantasy%20Korean%20webtoon%20cover%20featuring%20a%20cozy%20magical%20restaurant%20with%20fantasy%20creatures%2C%20warm%20interior%2C%20manhwa%20art%20style%2C%20inviting%20atmosphere%2C%20Korean%20comic%20illustration&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '失业厨师朴大成的餐厅即将倒闭的那天晚上，餐厅的大门突然连接到了一个奇幻世界。精灵、矮人、兽人、龙族纷纷成为他的顾客。凭借一手好厨艺，他在异世界开起了最火爆的餐厅。然而美食带来的不仅是财富，还有来自各方势力的觊觎。这是一部美食与奇幻交织的治愈故事。',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    tags: ['美食', '异世界', '治愈'],
    rating: 9.6,
    views: 1450000,
    chapters: 82,
    status: '连载中',
    updatedAt: '2026-08-04',
    createdAt: '2025-02-14',
    chapters_list: [
      { id: 1, title: '第1话：最后一碗泡菜汤', number: 1, updatedAt: '2025-02-14', content: '深夜，餐厅里只剩下朴大成一个客人也没有。他煮了最后一碗泡菜汤，独自一人坐在空荡荡的餐厅里。"是时候关门了..."突然，厨房后门传来了奇异的金色光芒...' },
    ],
  },
  {
    id: 11,
    title: '我的邻居是吸血鬼',
    author: '张瑞希',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20romantic%20Korean%20webtoon%20cover%20featuring%20a%20mysterious%20vampire%20in%20modern%20Seoul%2C%20gothic%20elements%2C%20manhwa%20art%20style%2C%20warm%20dark%20tones%2C%20Korean%20comic%20illustration%2C%20supernatural%20romance&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '搬进新公寓的普通上班族吴世英发现，住在隔壁的神秘邻居只在夜晚出门，而且从不吃东西。一次偶然的相遇让她发现了真相——他是一只活了三百年的吸血鬼。但这个吸血鬼却拥有着一颗比任何人都温柔的心。一部关于永生与爱情的奇幻都市故事。',
    category: '都市生活',
    categorySlug: 'urban',
    tags: ['奇幻', '恋爱', '都市'],
    rating: 9.3,
    views: 1180000,
    chapters: 60,
    status: '连载中',
    updatedAt: '2026-07-31',
    createdAt: '2025-10-08',
    chapters_list: [
      { id: 1, title: '第1话：奇怪的邻居', number: 1, updatedAt: '2025-10-08', content: '吴世英拖着行李箱走进新公寓的电梯。门快要关上的瞬间，一只苍白修长的手伸了进来。"不好意思。"低沉而富有磁性的声音。她抬头一看，被那双深邃的红色眼眸震慑住了...' },
    ],
  },
  {
    id: 12,
    title: '天才围棋少年',
    author: '金明洙',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20intense%20Korean%20drama%20webtoon%20cover%20featuring%20a%20young%20baduk%20go%20player%20in%20competition%2C%20focused%20expression%2C%20manhwa%20art%20style%2C%20warm%20tones%2C%20Korean%20comic%20illustration%2C%20sports%20theme&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '从小在孤儿院长大的柳泰俊，唯一的爱好是围棋。十岁那年，他在公园里偶遇了一位隐居的围棋大师，开始接受系统训练。十五岁成为职业棋手，十八岁挑战世界冠军。在黑白交错的棋盘上，他用棋子书写着自己的传奇，同时也逐渐揭开了自己身世之谜。',
    category: '剧情',
    categorySlug: 'drama',
    tags: ['竞技', '成长', '热血'],
    rating: 9.8,
    views: 2100000,
    chapters: 105,
    status: '已完结',
    updatedAt: '2026-05-20',
    createdAt: '2024-06-01',
    chapters_list: [
      { id: 1, title: '第1话：公园里的老人', number: 1, updatedAt: '2024-06-01', content: '十岁的柳泰俊蹲在公园的石桌前，盯着上面的围棋棋盘发呆。其他孩子在玩耍，只有他对这些黑白棋子着迷。"小朋友，想学围棋吗？"一个白发苍苍的老人出现在他身后...' },
    ],
  },
];

export const heroComics = [comics[0], comics[5], comics[7]];

export const popularComics = [comics[2], comics[5], comics[11], comics[9], comics[0], comics[7]];

export const latestComics = [comics[9], comics[3], comics[10], comics[0], comics[7], comics[1], comics[4], comics[8]];

export const rankingComics = [comics[5], comics[0], comics[2], comics[9], comics[7], comics[6], comics[3], comics[10], comics[1], comics[4], comics[8], comics[11]];